import Phaser from 'phaser';
import type { SaveManager } from '@/game/systems/SaveManager';
import type { AudioManager } from '@/game/systems/AudioManager';
import { Background } from '@/game/objects/Background';
import { Cat } from '@/game/objects/Cat';
import { getCatById } from '@/data/cats';
import { getBackgroundById } from '@/data/backgrounds';
import { INTERNAL_HEIGHT, INTERNAL_WIDTH } from '@/game/config/GameConfig';
import { PALETTE, bodyTextStyle, createButton, createCoinPanel, titleTextStyle } from '@/game/ui/theme';

export class HomeScene extends Phaser.Scene {
  private saveManager!: SaveManager;

  constructor() {
    super('HomeScene');
  }

  create(): void {
    this.saveManager = this.game.registry.get('saveManager');
    const audioManager = this.game.registry.get('audioManager') as AudioManager;

    const backgroundId = this.saveManager.getSelectedBackgroundId() ?? 'sunsetHill';
    new Background(this, getBackgroundById(backgroundId));

    this.add.text(INTERNAL_WIDTH / 2, 140, 'Meow Melody', titleTextStyle(60)).setOrigin(0.5);
    this.add
      .text(INTERNAL_WIDTH / 2, 205, 'a rhythm snack-catching duet', bodyTextStyle(22, '#e9d9ff'))
      .setOrigin(0.5);

    const leftCat = new Cat(this, 'left', getCatById(this.saveManager.getData().selectedLeftCatId), INTERNAL_HEIGHT * 0.55);
    leftCat.setX(INTERNAL_WIDTH * 0.32);
    const rightCat = new Cat(this, 'right', getCatById(this.saveManager.getData().selectedRightCatId), INTERNAL_HEIGHT * 0.55);
    rightCat.setX(INTERNAL_WIDTH * 0.68);

    const playBtn = createButton(this, INTERNAL_WIDTH / 2, INTERNAL_HEIGHT * 0.68, 380, 90, 'Play', PALETTE.primary, 38);
    const catsBtn = createButton(this, INTERNAL_WIDTH / 2 - 130, INTERNAL_HEIGHT * 0.68 + 108, 220, 70, 'Cats', PALETTE.secondary);
    const songsBtn = createButton(this, INTERNAL_WIDTH / 2 + 130, INTERNAL_HEIGHT * 0.68 + 108, 220, 70, 'Songs', PALETTE.secondary);
    const backgroundsBtn = createButton(this, INTERNAL_WIDTH / 2 - 130, INTERNAL_HEIGHT * 0.68 + 186, 220, 70, 'Backgrounds', PALETTE.secondary, 22);
    const treatsBtn = createButton(this, INTERNAL_WIDTH / 2 + 130, INTERNAL_HEIGHT * 0.68 + 186, 220, 70, 'Treats', PALETTE.secondary);
    const settingsBtn = createButton(this, INTERNAL_WIDTH / 2, INTERNAL_HEIGHT * 0.68 + 264, 220, 70, 'Settings', PALETTE.panelLight);

    playBtn.on('pointerup', () => {
      audioManager.unlock();
      this.scene.start('SongSelectScene');
    });
    catsBtn.on('pointerup', () => this.scene.start('CatSelectScene'));
    songsBtn.on('pointerup', () => this.scene.start('SongSelectScene'));
    backgroundsBtn.on('pointerup', () => this.scene.start('BackgroundSelectScene'));
    treatsBtn.on('pointerup', () => this.scene.start('TreatSelectScene'));
    settingsBtn.on('pointerup', () => this.scene.start('SettingsScene'));

    createCoinPanel(this, INTERNAL_WIDTH - 110, 44, this.saveManager.getData().coins);
  }
}
